export enum Language {
  ZU = 'zu',
  EN = 'en',
}
export default Language;
